<template>
  <div class="w-full">
    <el-container class="h-full">
      <el-aside class="bg-gray-100" width="250px" style="height: 100%;">
        <app-menu :auth="auth" :forms="forms" :active-index="'form_'+ form_id" />
      </el-aside>
      <el-main class="m-0 p-0 bg-white">
        <div v-loading="loading" class="w-full h-full">
          <el-container class="flex flex-col h-full">
            <el-header height="50px" class="flex justify-between items-center form-navigation">
              <div class="authgroups">
                <template v-if="authGroups.length > 1">
                  <el-select v-model="group_id" size="small" value="1">
                    <el-option v-for="group in authGroups" :key="group.id" :value="group.id" :label="group.name" />
                  </el-select>
                </template>
                <template v-else>
                  <span v-for="group in authGroups" :key="group.id" class="menu-title">{{ group.name }}</span>
                </template>
              </div>
              <div v-if="auth.user.corp.is_owner"><span class="menu-title"><Link :href="zroute('app.form.edit', [app_id, form_id])"><el-button size="small">编辑表单</el-button></Link></span></div>
            </el-header>
            <template v-if="authGroups.length === 0 || !group.dataPerms.read">
              <el-main class="flex-1 overflow-y-auto">
                <fm-generate-form
                  v-if="!showResult"
                  ref="generateForm"
                  :data="jsonData"
                  :auth-member="authMember"
                  :value="editData"
                />
                <el-result v-else-if="showResult" class="p-0 w-full h-full" style="width: 80%;" icon="success" title="提交成功">
                  <template slot="extra">
                    <el-button type="primary" size="medium" @click="showResult=false">继续添加</el-button>
                  </template>
                </el-result>
              </el-main>
              <el-footer v-show="!showResult" class="flex flex-col justify-center form-footer">
                <el-row type="flex" align="middle">
                  <el-button type="primary" @click="submitForm('generateForm')">提交</el-button>
                  <el-button @click="resetForm('generateForm')">重置</el-button>
                </el-row>
              </el-footer>
            </template>
            <template v-else>
              <auth-manage :key="group.id" :auth-group-id="group.id" :perms="group.dataPerms" />
            </template>
          </el-container>
        </div>
      </el-main>
    </el-container>
  </div>
</template>
<script>

import zroute from '@/ziggy'
import axios from 'axios'
import Layout from '@/Shared/Layout'
import AppMenu from '../../components/AppMenu'
import {Link} from '@inertiajs/inertia-vue'
import AuthManage from '../../components/AuthManage'


export default {
  components: {
    AuthManage,
    AppMenu,
    Link,
  },
  layout: Layout,

  props: {
    forms: {
      type: Array,
      default: () => [],
    },
    list: {
      type: Array,
      default: () => [],
    },
    config: {
      type: Object,
      default: () => {},
    },
    auth: {
      type: Object,
      default: () => {},
    },
    authGroups: {
      type: Array,
      default: () => [],
    },
    authMember: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      group_id: this.authGroups.length > 0 ? this.authGroups[0].id : 0,
      app_id: zroute().params.app_id,
      form_id: zroute().params.form_id,
      showResult: false,
      loading: false,
      tempRoute: {},
      name: '',
      id: '',
      jsonData: {
        'list': this.list,
        'config': this.config ? this.config : {'labelWidth': 100, 'labelPosition': 'right', 'size': 'small', 'customClass': ''},
      },
      editData: {
        /* 需要加载的表单数据可以在这里进行设置 */
      },
    }
  },
  computed: {
    group() {
      return this.authGroups.find(group => group.id === this.group_id)
    },
  },
  watch: {
    form_id: {
      immediate: true,
      handler(val) {
        // console.log('form_id changed', val, this.$route.params);
        if (val === '') {
          this.id = this.$route.params.id
        } else {
          this.id = val
        }
        this.showResult = false
        this.getFormData()
      },
    },
  },
  created() {
    // this.getFormData();
    this.tempRoute = Object.assign({}, this.$route)

  },
  methods: {
    submitForm() {
      this.$refs.generateForm.getData().then(data => {
        console.log('submitForm', data)
        this.loading = true
        axios.post(zroute('app.entry.create', [this.app_id, this.form_id]), data).then(res => {
          this.loading = false
          this.showResult = true
        }).catch(err => {
          this.loading = false
          console.log(err)
        })
        // this.$inertia.post('', data, {
        //   onSuccess: (page) => {
        //     console.log(page)
        //   },
        // })

        // saveEntry({form_id: this.id, data: data}).then(res => {
        //   // this.$message.success('保存成功');
        //   this.loading = false;
        //   this.showResult = true;
        // }).catch(e => {
        //   this.$message.error('保存失败');
        // })
      })

    },
    resetForm(ref) {
      this.$refs[ref].reset()
    },
    getFormData() {
      // this.loading = true
      // getEntry({form_id: this.id}).then(res => {
      //   console.log(res);
      //   this.loading = false;
      //   this.jsonData.list = res.data.list;
      //   this.jsonData.config = res.data.config;
      //   this.name = res.data.name;
      //   this.editData = {};
      //   if (this.form_id === '') {
      //     // this.setTagsViewTitle();
      //   }
      // });
    },
    getAuthGroup() {
      // axios.
    },
  },
}
</script>

<style lang="scss" scoped>
.form-navigation {
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  padding: 0 20px;
  background: #fff;
  border-bottom: 1px solid #e9e9e9;
  .menu-title {
    max-width: 330px;
    font-weight: 700;
    font-size: 14px;
    line-height: 32px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}
.form-footer {
  align-items: flex-start;
  height: auto;
  background: #fff;
  padding: 0 24px;
  border-top: 1px dashed #e0e0e0;
}

.el-main {
  padding: 0;
  .el-result {
    padding: 0;
    width: 100%;
    height: 100%;
    margin: auto;
  }
  .fm-style {
    margin: 10px;
  }
}
.authgroups {
  ::v-deep .el-select {
    background: #f1f1f1;
    border-radius: 3px;
    cursor: pointer;
    .el-input__inner {
      border: 0;
      background-color: transparent;
      color: #1f2d3d;
      font-size: 14px;
      font-weight: 700;
      line-height: 30px;
    }
  }
}
</style>
